module.exports = __webpack_public_path__ + "static/media/picto-pack-video.072e2aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/picto-pack-video.png
// module id = 485
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 24